/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseTaskData } from './genericApiResponseTaskData';
import type { GenericApiResponseTaskMessage } from './genericApiResponseTaskMessage';
import type { GenericApiResponseTaskPagination } from './genericApiResponseTaskPagination';
import type { GenericApiResponseTaskError } from './genericApiResponseTaskError';

export interface GenericApiResponseTask {
  data?: GenericApiResponseTaskData;
  message?: GenericApiResponseTaskMessage;
  pagination?: GenericApiResponseTaskPagination;
  error?: GenericApiResponseTaskError;
  statusCode?: number;
}
